import validateTime from "./validateTime";

export default class Day {
  weeknum = null;

  open = [];

  close = [];

  active = false;

  openTimeIsValid = true;

  closeTimeIsValid = true;

  nextDay = false;
  
  periodOfNextDay = null;

  constructor(weeknum, open, close, active, nextDay, periodOfNextDay) {
    this.weeknum = weeknum;
    this.open = validateTime(open);
    this.close = validateTime(close);
    this.active = !!active;
    this.openTimeIsValid = true;
    this.closeTimeIsValid = true;
    this.nextDay = nextDay;
    this.periodOfNextDay = periodOfNextDay;
  }

  toJSON() {
    return this;
  }
}
